import {
    LogicOperator,
    GroupOperatorItem,
    Operator,
    OperatorItem,
} from '@components-clean/core/study-data-filter/advanced-select/advanced-select.interface';

export const operatorList: Array<OperatorItem> = [
    { value: Operator.Equals, label: 'equals' },
    { value: Operator.NotEqual, label: 'notEqual' },
    { value: Operator.Contains, label: 'contains' },
    { value: Operator.NotContains, label: 'notContains' },
    { value: Operator.GreaterThan, label: 'greaterThan' },
    { value: Operator.GreaterThanOrEqualTo, label: 'greaterThanOrEqualTo' },
    { value: Operator.LessThan, label: 'lessThan' },
    { value: Operator.LessThanOrEqualTo, label: 'lessThanOrEqualTo' },
    { value: Operator.Null, label: 'isBlank' },
    { value: Operator.NotNull, label: 'isNotBlank' },
];

export const boolOperators = [Operator.Equals, Operator.NotEqual, Operator.Null, Operator.NotNull];
export const stringOperators = [
    Operator.Equals,
    Operator.NotEqual,
    Operator.Contains,
    Operator.NotContains,
    Operator.Null,
    Operator.NotNull,
];
export const numericAndDateOperators = [
    Operator.Equals,
    Operator.NotEqual,
    Operator.GreaterThan,
    Operator.GreaterThanOrEqualTo,
    Operator.LessThan,
    Operator.LessThanOrEqualTo,
    Operator.Null,
    Operator.NotNull,
];

export const groupOperators: Array<GroupOperatorItem> = [
    { value: LogicOperator.AND, label: 'admin:AND' },
    { value: LogicOperator.OR, label: 'admin:OR' },
];

export const booleanValues = [
    { value: true, label: 'yes' },
    { value: false, label: 'no' },
];

// This should map to the API enum ScoreColor
export const ragColorValues = [
    { value: '3', label: 'Green' },
    { value: '2', label: 'Amber' },
    { value: '1', label: 'Red' },
    { value: '4', label: 'Purple' },
];

// This should map to the API enum ScoreColor
export const evaluationRagColorValues = [
    { value: '3', label: 'Green' },
    { value: '2', label: 'Amber' },
    { value: '1', label: 'Red' },
    { value: '0', label: 'None' },
];

// This should map to the API enum ScoreChange or ReviewLogChangeDirection which are the same as of 26.1
export const directionValues = [
    { value: '0', label: 'cm:increased' },
    { value: '1', label: 'cm:decreased' },
    { value: '2', label: 'cm:noChange' },
];
